"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const PeopleTable = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../peopleTable'))));
const AddPeopleAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./addPeopleAside'))));
const AddPeople = () => {
    const { setIsAddPeopleAsideOpen, setUserSelectedTeam, setPageLoading } = (0, zustandStore_1.useZustand)(state => ({
        setIsAddPeopleAsideOpen: state.setIsAddPeopleAsideOpen,
        setUserSelectedTeam: state.setUserSelectedTeam,
        setPageLoading: state.setPageLoading,
    }));
    const teamId = (0, zustandStore_1.useZustand)(state => state.team?.teamId || '');
    const [isNullState, setIsNullState] = (0, react_1.useState)(true);
    const [noteVisible, setNoteVisible] = (0, react_1.useState)(false);
    const { data: userData } = (0, teamQuery_1.useGetTeamUsersQuery)({ teamId });
    const users = userData?.users;
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    const cardProvider = companyPropertiesData?.cardprovider;
    const isAmexCardProvider = cardProvider === 'AMEX';
    const { data: userSelectedTeamData } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: whiteListedDomains = [] } = (0, companyQuery_1.useGetCompanyPropertyWhitelistedDomainsQuery)(currentUser?.companyAccountId || '');
    const { data: features } = (0, companyQuery_1.useGetCompanyFeaturesQuery)();
    (0, react_1.useEffect)(() => {
        setUserSelectedTeam(userSelectedTeamData?.[0] || '');
    }, [userSelectedTeamData, setUserSelectedTeam]);
    (0, react_1.useEffect)(() => {
        setIsNullState(!(users && users.length > 0));
    }, [users]);
    const updateButtons = ({ value = 'remove' } = {}) => {
        const usersLength = users?.length || 0;
        const length = value === 'remove' ? usersLength - 1 : usersLength + 1;
        setNoteVisible(length >= appConstants_1.teams.USERLIMIT);
    };
    (0, react_1.useEffect)(() => {
        if (teamId) {
            updateButtons();
        }
    }, [teamId]);
    (0, react_1.useEffect)(() => {
        setPageLoading(false);
    }, [setPageLoading]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Paper, { variant: "outlined", "ts-variant": "modal", children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: noteVisible && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "info", variant: "filled", "ts-variant": "purple-note", children: strings_1.messageStrings.WARNING_MESSAGE })) }), isNullState ? ((0, jsx_runtime_1.jsxs)(material_1.Box, { component: "div", sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    margin: 2,
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title", children: strings_1.addPeopleStrings.ADD_PEOPLE_HEADER_TITLE }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title-info", sx: {
                            margin: 1,
                        }, children: isAmexCardProvider
                            ? strings_1.addPeopleStrings.ADD_PEOPLE_HEADER_SUBTITLE_AMEX
                            : strings_1.addPeopleStrings.ADD_PEOPLE_HEADER_SUBTITLE_HSBC }), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, columnSpacing: 10, sx: {
                            padding: 4,
                        }, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { size: isAmexCardProvider ? 4 : 6, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { component: "div", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title", children: strings_1.addPeopleStrings.TEAM_OWNERS_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title-info", children: strings_1.addPeopleStrings.TEAM_OWNER_DESC })] }) }), isAmexCardProvider && ((0, jsx_runtime_1.jsx)(material_1.Grid, { size: 4, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { component: "div", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title", children: strings_1.addPeopleStrings.MANAGERS_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title-info", children: strings_1.addPeopleStrings.MANAGERS_DESC })] }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, { size: isAmexCardProvider ? 4 : 6, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { component: "div", children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title", children: strings_1.addPeopleStrings.MEMBERS_TEXT }), (0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title-info", children: strings_1.addPeopleStrings.MEMBERS_DESC })] }) })] }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, children: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "invitePeople-button", label: strings_1.addPeopleStrings.INVITE_PEOPLE_TEXT, onClick: () => setIsAddPeopleAsideOpen(true), color: uiConstants_1.UI_BUTTON_PRIMARY, disabled: features?.ENABLE_DOMAIN_WHITELISTING && whiteListedDomains.length === 0, style: { width: '30%' } }) })] })) : ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}), children: (0, jsx_runtime_1.jsx)(PeopleTable, {}) })), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}), children: (0, jsx_runtime_1.jsx)(AddPeopleAside, {}) })] }));
};
exports.default = AddPeople;
